import { render, staticRenderFns } from "./janflow.vue?vue&type=template&id=3985670f&lang=pug&"
import script from "./janflow.vue?vue&type=script&lang=js&"
export * from "./janflow.vue?vue&type=script&lang=js&"
import style0 from "./janflow.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports